import { Component, OnInit, ViewChild } from '@angular/core';
import { Output, EventEmitter } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { CommonDataService } from 'src/app/common/services/common-data.service';
import { GraphqlService } from 'src/app/common/services/graphql.service';
import { ValidationService } from 'src/app/common/services/validation.service';
import { MatSelect } from '@angular/material/select';

@Component({
  selector: 'app-provide-feedback',
  templateUrl: './provide-feedback.component.html'
})
export class ProvideFeedbackComponent implements OnInit {
  @Output() myEvent = new EventEmitter<string>();

  loadpagecontent: boolean = false;
  globalcancel: string;
  generalFeedbacklink: string;
  generalFeedbacktext: string;
  providefeedback: string;
  yourfeedback: string;
  globalsubmit: string;
  typeoffeedback: string;
  provideFeedbacksubtext: string;
  provideFeedbacktitle: string;
  feedbackTypeList: string[];
  textareaError: string = "";
  feedbackvalidationError: string;

  constructor(
    public commonDataService: CommonDataService,
    private graphQlService: GraphqlService,
    private _validationService: ValidationService,
  ) { }

  currentParagraph: string;
  navData = {
    crumbData: [],
  };

  feedBackForm = new FormGroup({
    feedBackType: new FormControl(''),
    feedBackContent: new FormControl(''),
  })

  passwordvalidation = new FormControl('');
  @ViewChild("feedBackTypeSelect", { static: false }) nameField: MatSelect;

  ngOnInit(): void {
    this.getProfessionalContent();
    this.getprovideFeedbackDropdownValues();
  }

  public hasError = (controlName: string, errorName: string) => {
    return this.feedBackForm.controls[controlName].hasError(errorName);
  }

  getProfessionalContent() {
    this.graphQlService.getGlobalLabels().subscribe(data => {
      if (data != null) {
        this.loadpagecontent = true;
        var labels = data.content.data.labels;
        labels = labels.filter(x => x.key.trim());
        this.providefeedback = labels.filter(x => x.key == "provideFeedback_header").map(y => y.value);
        this.provideFeedbacksubtext = labels.filter(x => x.key == "provideFeedback_subtext").map(y => y.value);
        this.typeoffeedback = labels.filter(x => x.key == "provideFeedback_title").map(y => y.value);
        this.yourfeedback = labels.filter(x => x.key == "provideFeedback_body").map(y => y.value);
        this.globalcancel = labels.filter(x => x.key == "global_cancel").map(y => y.value);
        this.globalsubmit = labels.filter(x => x.key == "global_submit").map(y => y.value);
        this.generalFeedbacktext = labels.filter(x => x.key == "generalFeedback_text").map(y => y.value);
        this.generalFeedbacklink = labels.filter(x => x.key == "generalFeedback_link").map(y => y.value);
      }
      else {
        //TODO : check the negative scenario        
      }
    });
  }


  getprovideFeedbackDropdownValues() {
    this.graphQlService.getprovideFeedbackDropdown().subscribe(data => {
      if (data != null) {
        this.loadpagecontent = true;
        this.feedbackTypeList = data.content.data.listItem
      }
    });
  }

  closeOverlay() {
    this.myEvent.emit();
  }

  remainingText: number = 0;
  annotationDescriptionChange(value: string) {
    this.remainingText = 4000 - value.length;
  }

  addGeneralFeedback() {
    this.commonDataService.rightOverlayOption.next("General Feedback");
  }

  checkHome() {
  }

  checkfeedBackType() {
    let isValid = true;
    if (!this._validationService.validateRequiredField(this.feedBackForm.controls.feedBackType.value)) {
      this.feedBackForm.controls.feedBackType.setErrors({ 'isEmpty': true });
      this.feedbackvalidationError = this._validationService.getErrorMessage('required', this.typeoffeedback, null);
      this.feedBackForm.controls.feedBackType.markAsTouched();
      isValid = false
    }


    if (isValid) {
      this.feedBackForm.controls.feedBackType.setErrors(null);
      this.feedbackvalidationError = '';
    }

    return isValid;
  }

  checkfeedBackContent() {
    let isfeedBackContentValid = true;
    if (!this._validationService.validateRequiredField(this.feedBackForm.controls.feedBackContent.value) || this.feedBackForm.controls.feedBackContent.value.trim() == "") {
      this.feedBackForm.controls.feedBackContent.setErrors({ 'isEmpty': true });
      this.feedbackvalidationError = this._validationService.getErrorMessage('required', this.yourfeedback, null);
      this.feedBackForm.controls.feedBackContent.markAsTouched();
      isfeedBackContentValid = false
    }


    if (isfeedBackContentValid) {
      this.feedBackForm.controls.feedBackContent.setErrors(null);
      this.feedbackvalidationError = '';
    }

    return isfeedBackContentValid;
  }

  submittFeedback() {
    let checkfeedBackTypeValid = this.checkfeedBackType()
    if (checkfeedBackTypeValid) {
      let checkfeedBackContentValid = this.checkfeedBackContent();
      if (checkfeedBackContentValid) {
        // code here
        console.log("success from provide feedback validation");
      }
    }
  }

}
